import React from 'react';
import classNames from 'classnames/bind';
import { compose } from '@beef/utils';
import { connect } from 'react-redux';
import { selectNotAuthData, selectNotAuthPending } from "../../../../../store/selectors";
import styles from "./styles.pcss";
import { HighlightsTitle } from "../HighlightsTitle";
import { QRCode } from "../QRCode";
import { AppBannerSkeleton } from "../AppBannerSkeleton";
import { StoresIcons } from "../StoresIcons";
import { AppBannerLayout } from "../AppBannerLayout";
var cn = classNames.bind(styles);
export var AppBanner_ = function AppBanner_(_ref) {
  var qpTexts = _ref.qpTexts,
    pending = _ref.pending;
  if (pending) {
    return /*#__PURE__*/React.createElement(AppBannerSkeleton, {
      "data-t-id": "components-AppBanner"
    });
  }
  var storeLinks = {
    googlePlay: qpTexts.googlePlayLink,
    appGallery: qpTexts.huaweiLink,
    appStore: qpTexts.appleLink,
    ruStore: qpTexts.ruStoreLink
  };
  return /*#__PURE__*/React.createElement(AppBannerLayout, {
    href: storeLinks.appStore
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('title'),
    "data-t-id": "components-AppBanner"
  }, /*#__PURE__*/React.createElement(HighlightsTitle, {
    highLightStr: qpTexts.subtitleLight,
    title: qpTexts.subtitleDark
  })), /*#__PURE__*/React.createElement(QRCode, {
    imgUrl: qpTexts.icon,
    qrCodeUrl: qpTexts.qrCode
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('icons')
  }, /*#__PURE__*/React.createElement(StoresIcons, {
    storeLinks: storeLinks
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    qpTexts: selectNotAuthData(state),
    pending: selectNotAuthPending(state)
  };
};
export var AppBanner = compose(connect(mapStateToProps))(AppBanner_);